import React from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import TextLoadingBox from 'components/Luxkit/Typography/TextLoadingBox'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'

const StyledTextLoadingBox = styled(TextLoadingBox)`
  min-height: ${rem(124)};
`

interface Props {
  verticalGap?: 0 | 4 | 2 | 8 | 12 | 16 | 20 | 24 | 32 | 40 | 48 | 56;
  textWidth?: number;
  boxWidth?: number;
}

function HotelSearchCarouselLoadingTile({
  verticalGap = 8,
  boxWidth = 220,
  textWidth = 100,
}: Props) {
  return (
    <VerticalSpacer gap={verticalGap}>
      <StyledTextLoadingBox width={boxWidth}/>
      <TextLoadingBox typography="body-medium" width={textWidth}/>
    </VerticalSpacer>
  )
}

export default HotelSearchCarouselLoadingTile
